import { useEffect, useState } from "react";
import QRScan from "../../components/qr_scan";
import { Controller, useForm } from "react-hook-form";
import CONFIG from "../../constanta/config";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import useUser from "../../hook/useUser";
import ReactSelect from "react-select";

const FormAddUser = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [tempName, setTempname] = useState("");

  const [msg, setMsg] = useState(null);
  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const getBaseUrl = () => {
    if(window?.location?.origin){

        var apiUrl = `${CONFIG.URL_ROOT}/checkin`;
        return apiUrl;
    }
    else{
        return "";
    }
  }

  useEffect(() => {
    setTimeout(() => {
      setMsg(null);
    }, 1500);
  }, [msg]);

  const onSubmit = (data) => {
    if (loading) return;


    setTempname(data.name);
    setLoading(true);
    const payload = {
      name: data.name,
      user_type: data.type,
      authorized_by: data.authorized,
    };

    console.log(payload);

    var form_data = new FormData();

    for (var key in payload) {
      form_data.append(key, payload[key]);
    }

    try {
      axios
        .post(CONFIG.URL + "/user/add", form_data, {
          headers: {
            token: Cookies.get("token"),
          },
        })

        .then(function (response) {
          setLoading(false);
          if (response?.data.status === "SUCCESS") {
            reset();
            setMsg({
              success: true,
              msg: "Success Add User",
            });

            setTimeout(() => {
              window.location.href = getBaseUrl();
            }, 1500);
          } else {
            setMsg({
              success: false,
              msg: "Failed Add User",
            });
          }
        })
        .catch(function (error) {
          setLoading(false);
          setMsg({
            success: false,
            msg: "Failed Add User",
          });
        });
    } catch (error) {
      setLoading(false);
      setMsg({
        success: false,
        msg: "Failed Add User",
      });
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="space-y-5 px-5 py-5 bg-white rounded-md w-full md:w-1/2"
      >
        <div className="text-center font-bold mb-5">
          <div className="text-2xl">ADD USER</div>
        </div>

        {msg !== null && msg?.success && (
          <>
            <div className="text-center font-bold mb-8">
              <div className="text-2xl mt-5">
                Hi, {tempName}
              </div>
            </div>

            <div className="bg-green-500 w-full text-center py-5 text-white font-bold rounded">
              CHECKIN SUCCESS
            </div>
          </>
        )}

        {msg !== null && !msg?.success && (
          <div className="text-center font-bold text-white bg-red-500 py-2 rounded">
            {msg?.msg}
          </div>
        )}

        {(msg === null || !msg?.success) && (
          <>
            <div className="flex flex-col">
              <label className="text-black w-full">Name:</label>

              <input
                autoFocus
                className="border-2 px-2 h-[38px] rounded"
                {...register("name", { required: true })}
              />

              {errors.name && (
                <span className="text-red-500 text-sm">
                  This field is required
                </span>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-black w-full">Type:</label>

              <input
                className="border-2 px-2 h-[38px] rounded"
                {...register("type", { required: false })}
              />
            </div>

            <div className="flex flex-col">
              <label className="text-black w-full">Authorized By:</label>

              <input
                className="border-2 px-2 h-[38px] rounded"
                {...register("authorized", { required: false })}
              />
            </div>

            <div className="flex space-x-5">
              <a
                href="./checkin"
                className={` min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-red-500  w-full text-center`}
              >
                Cancel
              </a>
              <button
                type="submit"
                className={`min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-green-500  w-full text-center`}
              >
                {loading ? "Loading..." : "Submit"}
              </button>
            </div>
          </>
        )}
      </form>
    </>
  );
};

export default FormAddUser;
